// extracted by mini-css-extract-plugin
export default {"select_auto_button":"SelectAutoButton-module__select_auto_button--JE6Np"};